import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { SignupconfirmComponent } from './signup-confirm/signup-confirm.component';
import { ForgotpassComponent } from './forgotpass/forgotpass.component';
import { ForgotpassconfirmComponent } from './forgotpass-confirm/forgotpass-confirm.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoaderModule } from '../loader/loader.module';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { InputOtpModule } from 'primeng/inputotp';


@NgModule({
  declarations: [LoginComponent,SignupComponent,SignupconfirmComponent,ForgotpassComponent,ForgotpassconfirmComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoaderModule,
    DialogModule,
    InputOtpModule
  ],
  providers: [MessageService]
})
export class UserManagementModule { }
